import { render } from "./Lectura1.vue?vue&type=template&id=262e58d4"
import script from "./Lectura1.vue?vue&type=script&lang=js"
export * from "./Lectura1.vue?vue&type=script&lang=js"

import "./Lectura1.vue?vue&type=style&index=0&id=262e58d4&lang=css"
script.render = render

export default script